import {takeEvery} from 'redux-saga/effects'
import {GET_B_DEVICE_CSV_LOGS} from 'setup/redux/Actions/BiometricDeviceLog/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_B_DEVICE_CSV_LOGS, fetchData)
}

export default dataSaga
